import { cn } from "@/shared/lib/utils"
import { PLACEMENT_LABEL, type PlacementState } from "../lib/placement"

const DOT: Record<PlacementState, string> = {
	live: "bg-emerald-400",
	scheduled: "bg-sky-400",
	failed: "bg-red-400",
	off: "bg-muted-foreground/40",
}

const TEXT: Record<PlacementState, string> = {
	live: "text-foreground",
	scheduled: "text-sky-300",
	failed: "text-red-300",
	off: "text-muted-foreground",
}

/** Состояние на площадке точкой и словом: в таблице читается быстрее, чем цветная плашка. */
export function PlacementPill({
	state,
	label,
	className,
}: {
	state: PlacementState
	/** Своя подпись вместо стандартной, например «Канал». */
	label?: string
	className?: string
}) {
	return (
		<span
			className={cn("inline-flex items-center gap-1.5 text-sm whitespace-nowrap", TEXT[state], className)}
		>
			<span
				aria-hidden
				className={cn(
					"size-2 shrink-0 rounded-full",
					DOT[state],
					state === "live" && "shadow-[0_0_0_3px_color-mix(in_oklab,var(--color-emerald-400)_18%,transparent)]",
				)}
			/>
			{label ?? PLACEMENT_LABEL[state]}
		</span>
	)
}
